function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.805 6.224l1.668-1.794L15 12l-7.032-1.65 1.49-1.603a10.59 10.59 0 00-.253-.282C8.38 7.58 6.741 6.14 5.065 6.464c-1.273.246-2.389 1.474-3.315 3.65-.086.2-.3.296-.493.22a.396.396 0 01-.142-.097.443.443 0 01-.1-.412c.28-1.065 1.414-4.613 4.243-5.586 1.89-.65 4.093.03 6.547 1.985z",
  fill: "currentColor"
})));